import Storage from "./storage"

export default {

  sendLogs: function(log, reqBody, headers) {
    var data = {
      zoom_sdk_user_guid: Storage.get("zoom_sdk_user_guid"),
      log: log,
      body: reqBody
    }
    var url = 'https://cache.zoomauth.com:6999/zoomsdklog';
    if (window.location.host.indexOf("localhost") > -1) {
      // url = 'http://localhost:6999/zoomsdklog';
    }

    postData(url, data)
    .then(data => console.log(JSON.stringify(data))) // JSON-string from `response.json()` call
    .catch(error => console.error(error));

    function postData(url = '', data = {}) {
      // Default options are marked with *
        return fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: headers,
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // no-referrer, *client
            body: JSON.stringify(data), // body data type must match "Content-Type" header
        })
        .then(response => response.json()); // parses JSON response into native Javascript objects
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/utilities/log-errors-to-zc.jsx